export default __webpack_public_path__ + "static/13-invoices-44b6f4cfbc5e07714e5bc2a1f69aeffd.png";